import { render, staticRenderFns } from "./TestSohagy.vue?vue&type=template&id=93edea8a&"
import script from "./TestSohagy.vue?vue&type=script&lang=js&"
export * from "./TestSohagy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports